import { render, staticRenderFns } from "./VContent.vue?vue&type=template&id=5a4fe294&scoped=true"
import script from "./VContent.vue?vue&type=script&lang=js"
export * from "./VContent.vue?vue&type=script&lang=js"
import style0 from "./VContent.vue?vue&type=style&index=0&id=5a4fe294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4fe294",
  null
  
)

export default component.exports